import styled from 'styled-components';
import { LinkButton } from 'components/ui/Button';

export const CardReferenceLink = styled(LinkButton)`
  margin: 0;
  padding: 0;
  font-size: clamp(12px, 1.1vw, 20px);
  height: clamp(12px, 1.1vw, 20px);
  font-weight: normal;
  word-break: break-all;
`;

export const CardReferenceContent = styled('span')`
  word-break: break-all;
`;
